import { Button, Modal, Spinner } from "flowbite-react"
import React, { useState } from "react"

import { ArrowRightIcon, ExclamationMarkIcon } from "@assets/icons"

interface IPaymentConfirmationModalProps {
  show: boolean
  setShowPaymentConfirmation: React.Dispatch<React.SetStateAction<boolean>>
  paylaterAmount: string
  pendingProducts: string[]
  handleContinueOrder: () => void
  handleClose: () => void
  isLoading: boolean
}
const PaymentConfirmationModal = ({
  show,
  setShowPaymentConfirmation,
  paylaterAmount,
  pendingProducts = [],
  handleContinueOrder,
  handleClose,
  isLoading,
}: IPaymentConfirmationModalProps) => {
  const [isSubmitting, setIsSubmitting] = useState(false)

  const handleCancelBtn = () => {
    handleClose()
    setIsSubmitting(false)
    setShowPaymentConfirmation(true)
  }

  const handleContinueBtn = () => {
    setShowPaymentConfirmation(false)
    setIsSubmitting(true)
    handleContinueOrder()
  }
  return (
    <Modal className={"widget-theme-wrapper"} show={show} onClose={handleClose} size={"lg"}>
      <Modal.Header className={"border-b-0 pb-0 !bg-lightBg"} />
      <Modal.Body className={"px-6 pt-2 pb-8"}>
        <ExclamationMarkIcon className={"mx-auto mb-5"} />
        <div className={"text-center mb-8"}>
          <div className={"text20Semibold"}>
            Pending Bookings :{" "}
            <span className={"text-orange-800"}>Pay Later - {paylaterAmount}</span>
          </div>
          <div className={"text-neutral-600 text14Regular mt-4 mb-2"}>
            Your booking for{" "}
            <span className={"text-neutral-1000 text14Semibold"}>
              ‘{pendingProducts.join(",")}’
            </span>{" "}
            is pending confirmation by the operator. You will receive an email notification once the
            booking is either confirmed or cancelled.
          </div>
          <div className={"text14Semibold text-neutral-900"}>
            Please note, when booking is confirmed your card will be charged.
          </div>
        </div>
        <div className={"grid grid-cols-2 gap-2"}>
          <Button
            color={"primary"}
            className={"!whitespace-nowrap"}
            onClick={handleContinueBtn}
            disabled={isLoading && isSubmitting}
          >
            {isLoading && isSubmitting ? (
              <Spinner size={"sm"} light className={"text-primary-400 fill-white"} />
            ) : (
              <>
                Continue Order <ArrowRightIcon className={"ml-2 h-5 w-5"} />
              </>
            )}
          </Button>
          <Button color={"ghost"} outline onClick={handleCancelBtn}>
            Cancel
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  )
}

export default PaymentConfirmationModal
